<div class="container-fluid py-4">
  <div class="row justify-content-center">
    <div class="col-3 col-md-2" *ngFor="let card of resumenCards; index as i">
      <!-- <div
        [class]="i < 3 ? 'col-md-4' : 'col-md-3'"
        *ngFor="let card of resumenCards; index as i"
      > -->
      <div
        class="card card-stats"
        [ngClass]="{ 'card-stats__selected': i === 0 }"
        [routerLink]="card.route"
        [style.cursor]="card.route || i === 0 || 1 ? 'pointer' : 'default'"
      >
        <!-- (click)="i === 0 ? getInternal() : null" 
           (click)="handleCardClick(i)"-->
        <div class="card-body">
          <div class="row">
            <div class="col-12 col-md-6 col-lg-6">
              <div
                class="icon-big text-center text-dark rounded shadow icon-card"
                [ngClass]="card.bgClass"
              >
                <i [class]="card.icon"></i>
              </div>
            </div>
            <div class="col-7 d-flex flex-column justify-content-center">
              <p class="card-category mb-0">{{ card.label }}</p>
              <h4
                class="card-title mb-0"
                [ngClass]="{ 'text-dark': i === 0, 'text-white': i !== 0 }"
              >
                {{ card.value }}
              </h4>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="stats">
            <small [class]="i == 0 ? 'desc__selected' : 'desc'">{{
              card.desc
            }}</small>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12 d-flex align-items-center justify-content-between">
      <div class="flex-grow-1 text-center">
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/marketing/seo/registry']"
        >
          Registry
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/marketing/seo/qaRun']"
        >
          QA Run
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/marketing/seo/internalLinks']"
        >
          Internal Links
        </a>
        <a class="btn btn-dark btn-sm btn-reg"> On-P Insights </a>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12 d-flex align-items-center justify-content-between">
      <div class="flex-grow-1 text-center">
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/marketing']"
        >
          Keywords
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/marketing/seo/offPageRecommendations']"
        >
          Off-P Recomm
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/marketing/seo/offPageProspects']"
        >
          Off-P Prospects
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/marketing/seo/offPageBacklinks']"
        >
          Off-P Backlinks
        </a>
      </div>
    </div>
  </div>

  <!-- <div class="row mb-4">
      <div class="col-12">
        <h2 class="mb-0">SEO Off-Page Dashboard</h2>
        <p class="text-muted">Overview of your off-page SEO strategy and campaigns.</p>
      </div>
    </div> -->
  <br>
  <br>

  <!-- Insights Cards -->
  <app-seo-off-page-insights></app-seo-off-page-insights>

  <!-- Navigation Buttons -->
  <!-- <div class="row mt-5">
      <div class="col-12">
        <h3 class="mb-4">Management Modules</h3>
      </div>
      <div class="col-md-3">
        <div
          class="card card-nav clickable shadow-hover"
          [routerLink]="['/marketing']"
        >
          <div class="card-body text-center py-5">
            <i
              class="material-icons mb-3"
              style="font-size: 48px; color: #ffa726"
              >campaign</i
            >
            <h4 class="card-title">Campaigns</h4>
            <p class="card-text">Manage all your SEO Off-Page campaigns.</p>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div
          class="card card-nav clickable shadow-hover"
          [routerLink]="['/marketing/seo/offPageRecommendations']"
        >
          <div class="card-body text-center py-5">
            <i
              class="material-icons mb-3"
              style="font-size: 48px; color: #26c6da"
              >lightbulb</i
            >
            <h4 class="card-title">Recommendations</h4>
            <p class="card-text">
              Review and approve link-building suggestions.
            </p>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div
          class="card card-nav clickable shadow-hover"
          [routerLink]="['/marketing/seo/offPageProspects']"
        >
          <div class="card-body text-center py-5">
            <i
              class="material-icons mb-3"
              style="font-size: 48px; color: #66bb6a"
              >person_search</i
            >
            <h4 class="card-title">Prospects</h4>
            <p class="card-text">Track potential opportunities and outreach.</p>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div
          class="card card-nav clickable shadow-hover"
          [routerLink]="['/marketing/seo/offPageBacklinks']"
        >
          <div class="card-body text-center py-5">
            <i
              class="material-icons mb-3"
              style="font-size: 48px; color: #43a047"
              >link</i
            >
            <h4 class="card-title">Backlinks</h4>
            <p class="card-text">
              Monitor status and verify your live backlinks.
            </p>
          </div>
        </div>
      </div>
    </div> -->
</div>
